(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["email-signup"] && !Shopify.designMode) return;
  try {
    const storageKey = 'email-signup-submitted';

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.classList.contains('email-signup__form') || form.id === '') return;

    try {
      sessionStorage.setItem(storageKey, form.id);
    } catch {
      /* sessionStorage can be blocked */
    }
  });

  const returnToSubmittedForm = () => {
    let submittedId = null;

    try {
      submittedId = sessionStorage.getItem(storageKey);
      sessionStorage.removeItem(storageKey);
    } catch {
      return;
    }

    if (!submittedId) return;

    const form = document.getElementById(submittedId);
    const message = form?.querySelector('.email-signup__message--status');
    if (!(form instanceof HTMLFormElement) || !(message instanceof HTMLElement)) return;

    document.querySelectorAll('.email-signup__message--status').forEach((node) => {
      if (node instanceof HTMLElement && node !== message) node.hidden = true;
    });
    message.hidden = false;

    if (message.classList.contains('email-signup__message--success')) {
      const fields = form.querySelector('.email-signup__fields');
      if (fields instanceof HTMLElement) fields.hidden = true;
    }

    form.scrollIntoView({ block: 'start' });

    const invalidField = form.querySelector('[aria-invalid="true"]');
    if (invalidField instanceof HTMLElement) {
      invalidField.focus({ preventScroll: true });
      return;
    }

    message.focus({ preventScroll: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', returnToSubmittedForm);
  } else {
    returnToSubmittedForm();
  }
  } catch(e) { console.error(e); }
})();

})();
